module.exports = __webpack_public_path__ + "media/images/emblems/Faoug-coat_of_arms-c01111ba6f52a1cedac951f270d0bd57.svg";